import { render, staticRenderFns } from "./PosWorkspace.vue?vue&type=template&id=45646aa6&scoped=true"
import script from "./PosWorkspace.vue?vue&type=script&lang=js"
export * from "./PosWorkspace.vue?vue&type=script&lang=js"
import style0 from "./PosWorkspace.vue?vue&type=style&index=0&id=45646aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45646aa6",
  null
  
)

export default component.exports